<template>
  <el-row class="commonRankBoard">
    <el-col :md="2"><div class="space"></div></el-col>

    <el-col :md="10" class="contentBox-L">
      <section class="title tac">
        <!-- <p>{{ $t(rankBoard_title) }}</p> -->
        <!-- 活动主标题 -->
        <p v-for="title in eventInfo.eventTitle.split('\n')" :key="title">{{ $t(title) }}</p>
      </section>

      <section class="rankBoard_btn">
        <span
          v-show="schoolMaxPages && personalMaxPages"
          class="rankBoard_btn__personal"
          :class="{ active: rank_index == 2 }"
          @click="(pageStart = 1), personalRankSearch(pageStart, pageSize, edition, gameId)"
          >{{$t("个人榜")}}
        </span>
        <span v-show="schoolMaxPages && personalMaxPages"
          class="rankBoard_btn__school"
          :class="{ active: rank_index == 1 }"
          @click="(pageStart = 1), schoolRankSearch(pageStart, pageSize, eventInfo.eventCode)"
          >{{$t("学校榜")}}
        </span>

        <span
          v-show="schoolMaxPages == 0 && personalMaxPages == 0"
          class="rankBoard_btn__personal"
          >本次比赛不展示排行榜
        </span>
      </section>

      <section
        v-show="showGroupOption"
        class="rankBoard_btn"
        :class="{
          isShow: rank_index == 2
        }"
      >
        <span
          v-for="(item, index) in personalListTable"
          :key="index"
          :class="{ active: rankTwo_index == index + 1 }"
          @click="
            handle_rankTwo_index_Search(item.levelProgress, item.gameId),
              (rankTwo_index = index + 1)
          "
          >{{ getGroupName(item.gameName) }}
        </span>


      </section>

      <div
        v-show="schoolMaxPages || personalMaxPages"
        class="tableLoadingWrapper"
        v-loading="loading"
        :element-loading-text='$t("Data_Loading")'
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-table
          class="tableCss mobile-table"
          :data="dataTable"
          border
          v-if="isMobileOrDesktop === true"
        >
          <el-table-column
            prop="rank"
            :label='$t("Rank")'
            min-width="80"
            align="center"
          ></el-table-column>

          <el-table-column
            min-width="200"
            :label="$t('School')"
            align="center"
          >
            <template slot-scope="scope">
              <p>{{ scope.row.firstName }}</p>
              <p style="font-size: 0.5em">{{ scope.row.schoolCnName }}</p>
            </template>
          </el-table-column>

          <el-table-column
            prop="totalScore"
            label="总成绩"
            min-width="80"
            align="center"
          ></el-table-column>
        </el-table>

        <el-table
          class="tableCss desktop-table"
          :data="dataTable"
          border
          v-if="isMobileOrDesktop === false"
        >
          <el-table-column
            prop="rank"
            :label= '$t("Rank")'
            min-width="50"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="firstName"
            :label='$t("Name")'
            min-width="120"
            align="center"
            v-if="rank_index != 1"
          ></el-table-column>

          <el-table-column
            prop="schoolCnName"
            :label='$t("School")'
            min-width="200"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="totalScore"
            :label='$t("总成绩")'
            min-width="80"
            align="center"
          ></el-table-column>
        </el-table>

        <el-pagination
          class="pagination-container"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="pageStart"
          :page-size="pageSize"
          :total="totalNum"
          :hide-on-single-page = 'true'
        ></el-pagination>
      </div>

      <div v-if="isCngefEvent" style="margin: 1em">
        <span style="color: yellow; font-size: medium;">
        特别提醒：排行榜附加题分数未完全计入，仅供参考，请以各省组委会最终公示为准
        </span>
      </div>

    </el-col>
    <el-col :md="1"><div class="space"></div></el-col>

    <el-col :md="9" class="contentBox-R">
      <div class="announcement">
        <div class="announceText">
          <span>{{ $t(announceContent) }}</span>
        </div>
      </div>

      <div class="images">
        <div class="container">
          <span>{{ $t("ICode_More_Info") }}</span>
          <i :class="getGzh()"></i>
        </div>
        <div class="container">
          <span>{{ $t("View_On_Phone") }}</span>
          <i class="qrcode" id="qrcode"></i>
        </div>
      </div>
    </el-col>

    <el-col :md="2"><div class="space"></div></el-col>
  </el-row>
</template>

<script>
import {
  getGameList,
  schoolRankSearch,
  userRankSearch
} from "../../api/home/home.js";
import { getEventInfo2 } from "../../api/event.js";
import wx from "weixin-js-sdk";
import Axios from "../../utils/request";
import QRCode from "qrcodejs2";
import I18nUtils from "../../utils/i18nUtil.js";
import { takeWhile } from "lodash";

// 记录GameId_Page
let gameIdPage = {}; 

const SCHOOL_RANKBOARD = 1;
const PERSONAL_RANKBOARD = 2;

export default {
  data() {
    return {
      isCngefEvent: false,
      showGroupOption: false, // 第二排按钮是否显示 | 默认false

      /////// 排行榜 ////////
      // false 是桌面端 ； true是移动端
      isMobileOrDesktop: false,

      loading: false,
      dataTable: [],
      personalListTable: [],
      /**
       * 排行榜索引
       * 学校榜为 “1”，从左至右递增
       * 点击按钮触发对应的func，并切换 rank_index 值
       * 可用于对应的细分组别按钮的取值
       */
      rank_index: 2,
      /**
       * 细分组别
       * 初级组、中级组、高级组
       * 下面数值为edition值
       * 定义的默认值-【0】
       * 初级组-【1】
       * 中级组-【3】
       * 高级组-【2】
       * 这个值等同于 edition 的值
       */
      rankTwo_index: 1,

      // gameId区分渠道用户； edition区分组别
      // 若排行榜和进入比赛功能在同一页面，需新增gameuserId来进行区分此两个功能
      edition: "",
      gameId: "",

      // pagination
      pageStart: 1,
      pageSize: 10,
      totalNum: 100,

      schoolPageStart: 1,
      schoolMaxPages: 10,

      personalPageStart: 1,
      personalMaxPages: 10,

      // 设置页面值
      eventCode: "",

      rankBoard_title: "",
      announceContent: "",
      /////// 排行榜 ////////

      eventInfo: {
        eventTitle: "",
      },
    };
  },

  methods: {
    async getEventInfo() {
      getEventInfo2(this.eventInfo).then((res) => {
          const _res = res.data;
          if (_res.code == 0) {
            this.eventInfo = _res.data;

            this.updateEventInfo();
          } else {
            this.$notify.error({
              title: this.$t("Event_Not_Ready"),
              message: "找不到对应的活动信息",
            });
          }
        });
    },


    getRandomDesc() {
      const qList = [
        "“笑傲江湖，还看今天”",
        "在这个竞争激烈的赛场上，每个人都在为了更高的排名而奋力拼搏。",
        "排名不仅仅是数字的堆砌，更是实力和努力的象征。",
        "每一分、每一秒，我们必须全力以赴。",
        "我们不断挑战自我，超越极限。",
        "速度的较量，更是智慧的较量。",
        "没有捷径可走，只有坚持不懈的努力。",
        "每一次排名的提升，都凝聚着无数汗水和努力。",
        "排名是荣誉的象征，也是鞭策我们不断进步的动力。",
        "每个人都是自己的英雄，都在为梦想而战。",
        "保持谦逊和尊重，因为每个人都有可能成为下一个超越者。",
      ];

      return qList[Math.floor(qList.length * Math.random())];
    },

    getGzh() {
      return "wx_gzh";
    },

    getGroupName(gameName){
      // 取中文括号（）内的内容
      let regex = /\（(.+?)\）/g;
      let groupName = gameName;
      const matches = gameName.match(regex)
      if (matches) {
        groupName = matches[matches.length - 1].replace("（","").replace("）","");
      }
      return groupName;
    },

    // 处理分页页码上的链接
    handleCurrentChange(page) {
      switch (this.rank_index) {
        case SCHOOL_RANKBOARD: {
          this.pageStart = 1;
          this.schoolRankSearch(page, this.pageSize, this.eventInfo.eventCode);
          break;
        }

        case PERSONAL_RANKBOARD: {
          this.pageStart = 1;
          gameIdPage[this.gameId] = page; // 记录页面

          this.personalRankSearch(
            page,
            this.pageSize,
            this.edition,
            this.gameId
          );
          break;
        }
      }
      
    },

    /**
     * 细分按钮功能
     * 根据排行榜的rank_index值的切换来选择对应的细分按钮
     */
    handle_rankTwo_index_Search(edition, gameId) {

      switch (this.rank_index) {
        case SCHOOL_RANKBOARD: {
          // rank_index = 1, 代表是学校榜 ，不显示细分按钮
          break;
        }

        // 若要添加更多其他名称的个人榜细分按钮，
        // 请在这里添加修改case，并且在getGameListHandler()函数的switch中同步添加case
        case PERSONAL_RANKBOARD: {
          switch (this.rankTwo_index) {
            case 1:
            case 2:
            case 3:
            case 4:
            {
              this.personalRankSearch(gameIdPage[gameId] || 1, this.pageSize, edition, gameId);
              break;
            }
          }
          break;
        }

        default: {
          this.$notify.error({
            title: "错误",
            message: "错误代码：xf-2"
          });
          break;
        }
      }
    },

    schoolRankSearch(pageStart, pageSize, eventCode) {
      this.showGroupOption = false;
      this.dataTable = [];
      this.rank_index = 1;
      this.loading = true;

      let maxRecord = this.schoolMaxPages * this.pageSize;

      setTimeout(() => {
        try {
          schoolRankSearch(pageStart, pageSize, eventCode).then(res => {
            const _res = res.data;

            if (_res.code == "0") {
              this.dataTable = _res.data;
              this.pageStart = pageStart;
              this.totalNum = _res.total >=  maxRecord ? maxRecord : _res.total;
              
            } else {
              this.$notify.error({
                title: "错误",
                message: "出错信息：" + _res.msg
              });
            }
          });
        } catch (e) {
          this.$notify.error({
            title: "错误",
            message: "出错信息：" + res.msg
          });
        }

        this.loading = false;
      }, 500);
    },

    /**
     * @param pageStart
     * @param pageSize
     * @param edition
     * @param gameId
     */
    personalRankSearch(pageStart, pageSize, edition, gameId) {
      this.showGroupOption = true;
      this.rank_index = 2;
      this.loading = true;

      let maxRecord = this.personalMaxPages * this.pageSize;

      setTimeout(() => {
        try {
          userRankSearch(pageStart, pageSize, edition, gameId).then(res => {
            const _res = res.data;

            if (_res.code == "0") {
              this.dataTable = _res.data;
              this.pageStart = pageStart;

              this.totalNum = _res.total >= maxRecord ? maxRecord : _res.total;

              this.gameId = gameId;
              this.edition = edition;
            } else {
              this.$notify.error({
                title: "错误",
                message: "出错信息：" + _res.msg
              });
            }

          });
        } catch (e) {
          this.$notify.error({
            title: "错误",
            message: "出错信息：" + res.msg
          });
        }

        this.loading = false;
      }, 500);
    },

    getGameListHandler(eventCode, refreshPersonData) {
      try {
        getGameList(eventCode).then(res => {
          const _res = res.data;

          if (_res.code == "0") {
            // 初始化Data值
            this.rankBoard_title = _res.data[0].eventName;

            // 若服务器中没有写入公告数据，则使用默认公告
            this.announceContent =
              _res.data[0].eventExplain != ""
                ? _res.data[0].eventExplain
                : this.announceContent;

            this.edition = _res.data[0].levelProgress;
            this.gameId = _res.data[0].gameId;

            this.personalListTable = _res.data;

            if(refreshPersonData){
              this.personalRankSearch(this.pageStart, this.pageSize, this.edition, this.gameId);
            } 

            // 微信分享链接支持
            // 微信开发者文档：https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#0
            let baseUrl = process.env.IX_URL;
            let linkUrl = process.env.RANK_BOARD_URL;
            let lastUrl = "?eventCode=" + this.eventInfo.eventCode;
            let imgUrl =
              "https://static.icode.org.cn/assets/ICODE_IX_ICODE.jpg";

            this.weChat(
              baseUrl,
              linkUrl,
              lastUrl,
              imgUrl,
              this.eventInfo.eventTitle
            );
            // 微信分享链接支持
          } else {
            this.$notify.error({
              title: "错误",
              message:
                "出错信息：" +
                _res.msg +
                "。代码：GEC-0，找不到排行榜信息，请确认访问链接是否正确！"
            });
          }
        });
      } catch (e) {
        this.$notify.error({
          title: "错误",
          message: "出错信息：" + res.msg
        });
      }
    },

    getEventCode() {
      let args = {};

      const qs =
        window.location.search.length > 0
          ? window.location.search.substr(1)
          : "";

      const itemsArray = qs.length > 0 ? qs.split("&") : [];

      itemsArray.forEach(el => {
        let item = el.split("=");
        let name = decodeURIComponent(item[0]);
        let value = decodeURIComponent(item[1]);

        if (name.length !== 0) {
          args[name] = value;

          if (name == "eventCode") {
            this.eventInfo.eventCode = value;
          }
        }
        return args;
      });
    },

    weChat(baseUrl, linkUrl, lastUrl, imgUrl, subTitle) {
      const wx_title = "ICode活动实时排行榜";
      const _subTitle = subTitle;
      const that = this;

      try {
        Axios({
          url: baseUrl + "/wechat/getWeChatSign",
          method: "post",
          data: {
            url: window.location.href.split("#")[0]
          }
        }).then(response => {
          const res = response.data;

          let _timestamp = res.data.timestamp;
          let _nonceStr = res.data.nonceStr;
          let _signature = res.data.signature;
          let _appId = res.appId;

          wx.config({
            debug: false, // 开启调试模式
            appId: _appId, // 必填，公众号的唯一标识
            timestamp: _timestamp, // 必填，生成签名的时间戳
            nonceStr: _nonceStr, // 必填，生成签名的随机串
            signature: _signature, // 必填，签名，见附录1
            jsApiList: [
              // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareQQ",
              "onMenuShareQZone"
            ]
          });
        });

        const shareConfig = {
            title: this.eventInfo.eventTitle,
            desc: that.getRandomDesc(),
            link: linkUrl + lastUrl,
            imgUrl: imgUrl,
            type: "link", // 分享类型,music、video或link，不填默认为link
          }

        // wx.ready接口处理成功验证
        wx.ready(function() {
          // share to friends
          wx.updateAppMessageShareData(shareConfig);
          wx.updateTimelineShareData(shareConfig);
          wx.onMenuShareQQ(shareConfig);
          wx.onMenuShareQZone(shareConfig);
        });
      } catch (e) {
        console.log(e);
      }
    },

    // 移动端页面支持
    moboleANDdesktop() {
      var os = (() => {
        var ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          // isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet =
            /(?:iPad|PlayBook)/.test(ua) ||
            (isAndroid && !/(?:Mobile)/.test(ua)) ||
            (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        };
      })();

      if (os.isAndroid || os.isPhone || os.isTablet) {
        this.isMobileOrDesktop = true;
      }
    },

    updateEventInfo(){
      if([835,834,833,716,715,714,713,712,711,710,709,708,707,706,705,704,703].includes(this.eventInfo.id)){
        this.isCngefEvent = true;
      }
      // 比赛配置
      this.schoolMaxPages = this.eventInfo.schoolRankMaxPage;
      this.personalMaxPages = this.eventInfo.personalRankMaxPage;

      // 仅显示学校排行榜
      if(this.schoolMaxPages && !this.personalRankboard){
        this.rank_index = 1;
        this.schoolRankSearch(this.pageStart, this.pageSize, this.eventInfo.eventCode);
        this.getGameListHandler(this.eventInfo.eventCode,false);

      } else { 
      // 仅显示个人排行榜
        this.rank_index = 2;
        this.getGameListHandler(this.eventInfo.eventCode, true); // 同时更新个人排行榜
      }

      document.title = this.eventInfo.eventTitle;

      // QRCODE 支持
      new QRCode(document.getElementById("qrcode"), window.location.href);

      // 判断PC端还是mobile端
      this.moboleANDdesktop();

      return;
    },
  },

  mounted() {
    this.eventInfo.channel = this.$route.params['channel'];
    this.getEventCode();
    this.getEventInfo();

    I18nUtils.initLanguage(this);
  }
};
</script>

<style lang="scss">
.commonRankBoard {
  width: 100vw;
  min-height: 100vh;
  background: url("./assets/bg.jpg") center / cover no-repeat;

  .contentBox-L {
    .title {
      padding: 8vh 0 5vh;
      font-size: 1.7vw;
      color: #fff;
      text-shadow: 0 0 0.3em #2daa8f, 0 0 0.2em #2daa8f, 0 0 0.2em #87f;
    }

    .rankBoard_btn {
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: space-around;
      font-size: 1.4vw;
      font-weight: bold;
      margin-bottom: 1.4vw;
      text-wrap: pretty;

      span {
        color: #b0a52b;
        transition: 0.4s ease;
        cursor: pointer;

        &:hover {
          color: #0ff;
        }
      }

      .active {
        font-weight: bold;
        padding: 5px;
        color: #0ff;
        background: url("./assets/btnBg-m.png") center / contain no-repeat;
        background-size: 100% 100%;
      }
    }

    .isNonShow {
      display: none;
    }

    .isShow {
      font-size: 1vw;
    }

    .tableLoadingWrapper {
      width: 90%;
      margin: 0 5%;

      .tableCss {
        color: #fff;
        border: 1px solid rgba(40, 187, 210, 0.9);
        border-radius: 2px;
      }

      // 修改board标签中的el-table元素属性
      .el-table {
        thead {
          color: #fff;
        }

        // 分割线条变色
        td,
        th.is-leaf {
          border-bottom: 1px solid #007e80;
        }

        &--border th,
        &--border td {
          border-right: 1px solid #007e80;
        }

        // 边框线条去除颜色
        &--border::after,
        &::before {
          background-color: unset;
        }

        // 背景色
        th {
          background-color: #1b7b9b;
        }

        tr {
          background-color: #002e48;
        }

        // 暂无数据 表现
        &__empty-block {
          background-color: #002e48;

          span {
            color: #fff;
          }
        }

        // 去除hover白底颜色
        &__body tr:hover > td {
          background-color: unset;
        }
      }

      .pagination-container {
        text-align: center;
        padding-top: 1.2vw;

        button {
          background: transparent;
          color: white;

          i.el-icon {
            font-size: 20px;

            &:hover {
              color: #007e80;
            }
          }
        }

        ul {
          border: none;

          li {
            background: transparent !important;
            color: white;
            font-size: 18px;
            border-bottom: none;

            &:hover {
              color: #007e80;
            }

            &.active {
              color: #fdec43;
            }
          }
        }

        .el-pagination {
          button:disabled {
            background-color: unset;
          }
        }
      }
    }
  }

  .contentBox-R {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .announcement {
      width: 30vw;
      max-width: 600px;
      height: 300px;

      margin-top: 10vh;
      background: url("./assets/steZh.png") center / contain no-repeat;
      font-size: 0.8vw;

      .el-carousel__container {
        height: 32vh;
      }

      .announceText {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        max-width: 500px;
        height: 100%;
        margin: 0 auto;
        margin-top: 10px;
        color: #fff;
      }
    }

    .images {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .container {
        box-sizing: border-box;
        margin: 3vw;
        color: #fff;
        font-size: 0.9vw;
        font-weight: bold;
        text-align: center;

        i {
          display: block;
          margin: 1vh 0;
          width: 10vw;
          height: 10vw;
        }

        .wx_gzh {
          background: url("./assets/wx_gzh.png") center / cover no-repeat;
        }

        .qrcode {
          background: url("./assets/wx_gzh_bg.png") center / cover no-repeat;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 75%;
          }
        }
      }
    }
  }

  .tac {
    text-align: center;
  }

  .space {
    background: unset;
    min-height: 36px;
  }

  @media (max-width: 1000px) {
    .contentBox-R {
      display: none;
    }

    .contentBox-L {
      .title {
        padding: 0.3rem 0.1rem 0.6rem;
        font-size: 0.4rem;
      }

      .rankBoard_btn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 0.5rem;
        font-weight: bold;
        margin-bottom: 0.4rem;

        span {
          color: #dbce41;

          &:hover {
            color: #0ff;
          }
        }

        .active {
          font-weight: bold;
          padding: 5px;
          color: #0ff;
          background: url("./assets/btnBg-m.png") center / contain no-repeat;
          background-size: 100% 100%;
        }
      }

      .isNonShow {
        display: none;
      }

      .isShow {
        font-size: 0.3rem;
      }

      .tableLoadingWrapper {
        width: unset;
        margin: unset;

        .pagination-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 0.3rem;
        }

        .el-pagination {
          .btn-prev {
            padding: 0;
          }

          .btn-next {
            padding: 0;
          }
        }

        .tableCss {
          width: 96%;
          margin: 0 2.1%;
        }

        .el-table {
          background-color: #002e48;

          td {
            padding: 10px 0;
          }

          .cell {
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/commonRankBoard/index.vue